import { connect } from 'react-redux';
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  PDFViewer,
  Font
} from "@react-pdf/renderer";
import moment from 'moment';
// Create styles
Font.register({ fontFamily: 'Roboto-Bold' });

const styles = StyleSheet.create({
  page: {
    backgroundColor: "white",
    color: "black",
    padding : 30
  },
  section: {
    margin: 10,
    padding: 10,
    display : "flex",
    justifyContent : "space-between"
  },
  Text : {
    fontFamily : "Roboto-Bold"
  },
  viewer: {
    width: window.innerWidth, //the pdf viewer will take up all of the width and height
    height: window.innerHeight,
  },
});

// Create Document Component
function BasicDocument(props) {
  let nbrAdulte ;
  let adultArray ;
  let enfantArray ;
  if (props.reservation.adult.length>0) {
    nbrAdulte = props.reservation.adult.length
    adultArray  = props.reservation.adult
    enfantArray = props.reservation.enfant
  }
  let announceData = props.announce ;
  let today = new Date();
  return (
    <PDFViewer style={styles.viewer}>
      {/* Start of the document*/}
      <Document>
        {/*render a single page*/}
        <Page size="A4" style={styles.page}>
          <View className="d-flex" style={{flexDirection: "row", justifyContent: "space-between"}} >
            <View>
              <Text style={{ fontWeight:"bold"}}>L&B Tourisme & Voyages</Text>
              <Text style={{fontSize: "10px", fontWeight : 100}}>Agence de Voyages - Skikda</Text>
              <Text  style={{fontSize: "10px", fontWeight : "100"}}>+213 (0) 673925711</Text>
            </View>
            
            <Text style={{fontSize: "12px", fontWeight : "200"}}>Généré le {moment(today).format('DD/MM/YYYY - HH:mm')} </Text>
          </View>
          <View style={{marginTop : "30px"}}>
            <Text style={{textAlign : "center", fontSize : "25px"}}>Récapitulatif de Réservation</Text>
            <Text style={{textAlign : "center", fontSize : "13px", marginTop : "10px"}}><Text style={{fontSize : "12px",color : "#303031"}}>Réf.</Text> HBG/12P/1174/00012</Text>
            <Text style={{textAlign : "center", fontSize : "13px",marginTop : "10px"}}><Text style={{fontSize : "12px",color : "#303031"}}>Pour </Text></Text>
          </View>
          <View style={{ padding: "40px 50px 0 50px"}}>
            <Text style={{fontSize: "9px",marginLeft : "10px",color : "gray"}}>Détails</Text>
            <View style={{flexDirection : "row", border : "1px",borderColor : "#a5a4a8",padding : "10px", borderRadius : "10px", marginTop : "5px"}}>
              <View>
                <Text style={{fontSize: "10px", marginBottom : "10px",color : "#303031"}}>Hébergement</Text>
                <Text style={{fontSize: "10px", marginBottom : "10px",color : "#303031"}}>Adresse</Text>
                <Text style={{fontSize: "10px", marginBottom : "10px",color : "#303031"}}>Arrivée</Text>
                <Text style={{fontSize: "10px", marginBottom : "10px",color : "#303031"}}>Checkout</Text>
                <Text style={{fontSize: "10px",color : "#303031"}}>Nuitées</Text>
              </View>
              <View style={{marginLeft : "20px"}}>
                <Text style={{fontSize: "10px", marginBottom : "10px"}}>{announceData.title}</Text>
                <Text style={{fontSize: "10px", marginBottom : "10px"}}>{announceData.commune} , {announceData.region} - {announceData.pays}</Text>
                <Text style={{fontSize: "10px", marginBottom : "10px"}}>Mar. 15 Mars 2022</Text>
                <Text style={{fontSize: "10px", marginBottom : "10px"}}>Jeu. 17 Mars 2022</Text>
                <Text style={{fontSize: "10px"}}>02</Text>
              </View>
              
            </View>
          </View>
          <View style={{ padding: "15px 50px"}}>
            <Text style={{fontSize: "9px",marginLeft : "10px",color: "gray"}}>Chambres</Text>
            <View style={{border : "1px",borderColor : "#a5a4a8", borderRadius : "10px", marginTop : "5px",overflow : "hidden"}}>
              <View style={{flexDirection: "row",justifyContent : "space-between" ,width : "100%", backgroundColor : "#716f7763", padding : "5px"}}>
                <Text style={{fontSize: "11px", width: "40%"}}>Type</Text>
                <Text style={{fontSize: "11px", width: "20%", textAlign : "center"}}>Pension</Text>
                <Text style={{fontSize: "11px", width: "20%", textAlign : "center"}}>Adultes</Text>
                <Text style={{fontSize: "11px", width: "20%", textAlign : "center"}}>Enfants</Text>
              </View>
              <View style={{flexDirection: "row",justifyContent : "space-between" ,width : "100%", padding : "5px"}}>
                <Text style={{fontSize: "9px", width: "40%"}}>1× Chambre Double Grand Lit + Lit Enfant</Text>
                <Text style={{fontSize: "9px", width: "20%", textAlign : "center"}}>Petit-déj</Text>
                <Text style={{fontSize: "9px", width: "20%", textAlign : "center"}}>{nbrAdulte}</Text>
                <Text style={{fontSize: "9px", width: "20%", textAlign : "center"}}>1</Text>
              </View>
              <View style={{flexDirection: "row",justifyContent : "space-between" ,width : "100%", padding : "5px"}}>
                <Text style={{fontSize: "9px", width: "40%"}}>1× Chambre Double Grand Lit + Lit Enfant</Text>
                <Text style={{fontSize: "9px", width: "20%", textAlign : "center"}}>Petit-déj</Text>
                <Text style={{fontSize: "9px", width: "20%", textAlign : "center"}}>2</Text>
                <Text style={{fontSize: "9px", width: "20%", textAlign : "center"}}>1</Text>
              </View>
              
            </View>
          </View>
          <View style={{ padding: "15px 50px"}}>
            <Text style={{fontSize: "9px",marginLeft : "10px",color: "gray"}}>Occupants</Text>
            <View style={{border : "1px",borderColor : "#a5a4a8", borderRadius : "10px", marginTop : "5px",overflow : "hidden"}}>
              <View style={{flexDirection: "row",justifyContent : "space-between" ,width : "100%", backgroundColor : "#716f7763", padding : "5px"}}>
                <Text style={{fontSize: "11px", width: "10%"}}>N°</Text>
                <Text style={{fontSize: "11px", width: "50%"}}>Nom et Prénom</Text>
                <Text style={{fontSize: "11px", width: "20%", textAlign : "center"}}>Type</Text>
                <Text style={{fontSize: "11px", width: "20%", textAlign : "center"}}>Age</Text>
              </View>
              {
                  adultArray.map((e,i)=>{
                    return (
                      <View style={{flexDirection: "row",justifyContent : "space-between" ,width : "100%", padding : "5px"}}>
                      <Text style={{fontSize: "9px", width: "10%"}}>{i+1}</Text>
                      <Text style={{fontSize: "9px", width: "50%"}}>{e.nom} {e.prenom}</Text>
                      <Text style={{fontSize: "9px", width: "20%", textAlign : "center"}}>Adult</Text>
                      <Text style={{fontSize: "9px", width: "20%", textAlign : "center"}}>{moment().diff(e.birthDay,"years")}</Text>
                    </View>
                    )
                  })
                }
              {
                  enfantArray.map((e,i)=>{
                    return (
                      <View style={{flexDirection: "row",justifyContent : "space-between" ,width : "100%", padding : "5px"}}>
                      <Text style={{fontSize: "9px", width: "10%"}}>{adultArray.length+i+1}</Text>
                      <Text style={{fontSize: "9px", width: "50%"}}>{e.nom} {e.prenom}</Text>
                      <Text style={{fontSize: "9px", width: "20%", textAlign : "center"}}>Enfant</Text>
                      <Text style={{fontSize: "9px", width: "20%", textAlign : "center"}}>10</Text>
                    </View>
                    )
                  })
                }
              
              
            </View>
           
          </View>
          <View style={{ padding: "15px 50px",flexDirection : "row", justifyContent : "flex-end"}}>
                  <Text style={{fontSize: "9px",marginRight: "10px",  color: "gray"}}>Montant à payer :</Text>
                  <View style={{border : "1px",borderColor : "#a5a4a8", borderRadius : "10px",overflow : "hidden",width : "50%"}}>
                    <View style={{flexDirection: "row",justifyContent : "space-between" ,width : "100%", padding : "5px 15px"}}>
                      <Text style={{fontSize: "9px", width: "70%"}}>1 Chambre × 2 Nuitées</Text>
                      <Text style={{fontSize: "9px", width: "30%"}}>30 000 DZD</Text>
                    </View>
                    <View style={{flexDirection: "row",justifyContent : "space-between" ,width : "100%", padding : "5px 15px"}}>
                      <Text style={{fontSize: "9px", width: "70%"}}>2 Chambres × 2 Nuitées</Text>
                      <Text style={{fontSize: "9px", width: "30%"}}>48 000 DZD</Text>
                    </View>
                    <View style={{flexDirection: "row",justifyContent : "space-between" ,width : "100%", padding : "10px 15px",borderTop : "1px",borderColor : "#a5a4a8"}}>
                      <Text style={{fontSize: "12px", width: "60%"}}>Total</Text>
                      <Text style={{fontSize: "12px", width: "40%",textAlign : "center"}}>78 000 DZD</Text>
                    </View>
                  </View>
            </View>
            <View style={{padding: "15px 50px"}}>
              <Text style={{fontSize: "12px", marginBottom : "5px"}}>Important</Text>
              <Text style={{fontSize: "9px",color : "gray"}}>
                Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut
                laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation
                ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat. Duis autem vel eum iriure dolor
                in hendrerit in vulputate velit esse molestie consequat, vel illum dolore eu feugiat nulla facilisis at vero 
              </Text>
            </View>
        </Page>
      </Document>
    </PDFViewer>
  );
}


function mapStateToProps(state) {
  return {
    reservation : state.reservationHeberg.reservation,
    announce : state.reservationHeberg.anounceReserved,
  }
}


export default connect(mapStateToProps)(BasicDocument);